/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import { ToolVariation, ToolVariation$inboundSchema } from "./toolvariation.js";

export type UpsertGlobalToolVariationResult = {
  variation: ToolVariation;
};

/** @internal */
export const UpsertGlobalToolVariationResult$inboundSchema: z.ZodMiniType<
  UpsertGlobalToolVariationResult,
  unknown
> = z.object({
  variation: ToolVariation$inboundSchema,
});

export function upsertGlobalToolVariationResultFromJSON(
  jsonString: string,
): SafeParseResult<UpsertGlobalToolVariationResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => UpsertGlobalToolVariationResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'UpsertGlobalToolVariationResult' from JSON`,
  );
}
